/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, jsx } from 'theme-ui'
import ProductLink from '~/components/Product/Link'
import ProductTags from '~/components/Product/Tags'

const ListingCardImage = ({
  callout,
  hoverImage,
  isLinked = true,
  mainImage,
  name,
  slug,
  slugUrl,
  tag,
}) => {
  if (isLinked) {
    return (
      <ListingCardImageLink name={name} slug={slug} slugUrl={slugUrl}>
        <ListingCardImages
          callout={callout}
          hoverImage={hoverImage}
          mainImage={mainImage}
          tag={tag}
        />
      </ListingCardImageLink>
    )
  }

  return (
    <ListingCardImages
      callout={callout}
      hoverImage={hoverImage}
      mainImage={mainImage}
      tag={tag}
    />
  )
}

const ListingCardImageLink = ({ children, name, slug, slugUrl }) => {
  return (
    <ProductLink slug={slug} slugUrl={slugUrl}>
      {children}
    </ProductLink>
  )
}

const ListingCardImages = ({ callout, hoverImage, mainImage, tag }) => {
  const hoverImageSx = hoverImage
    ? {
        'div:nth-of-type(2)': { opacity: '0', visibility: 'hidden' },
        '&:hover div:nth-of-type(2)': {
          opacity: [null, '1'],
          visibility: [null, 'visible'],
        },
      }
    : {}

  return (
    <Box
      sx={{
        position: 'relative',
        ...hoverImageSx,
      }}
    >
      <Box>
        <GatsbyImage
          image={mainImage.gatsbyImageData}
          alt={mainImage.description}
          key={mainImage.title}
          sx={{ display: 'block' }}
        />
      </Box>
      {hoverImage && (
        <Box
          sx={{
            left: '0',
            pointerEvents: 'none',
            position: 'absolute',
            right: '0',
            top: '0',
          }}
        >
          <GatsbyImage
            image={hoverImage.gatsbyImageData}
            alt={hoverImage.description}
            key={hoverImage.title}
          />
        </Box>
      )}
      {callout && (
        <Box sx={{ left: 0, position: 'absolute', top: 0 }}>{callout}</Box>
      )}
      {tag && (
        <Box
          sx={{
            bottom: '9px',
            left: '12px',
            pointerEvents: 'none',
            position: 'absolute',
          }}
        >
          <ProductTags tags={[tag]} />
        </Box>
      )}
    </Box>
  )
}

export default ListingCardImage
